export const BUILD_ID = `${process.env.BUILD_ID}`
export const BUILD_VERSION = `${process.env.NEXT_PUBLIC_CIRCLE_SHA1 || "noversion"}`
